import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusPastDue00Table: GenericTableSchemaInterface = {
  id: "fms-plus-past-due-00",
  name: "FMS+ Past Due 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Past Due workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "Account Balance",
      variable: VarKey.LeaseBalance
    },
    c05: {
      name: "Day that payment is due SMS"
    },
    c06: {
      name: "1 day after past due SMS"
    },
    c07: {
      name: "2 days after past due SMS"
    },
    c08: {
      name: "3 days after past due SMS"
    },
    c09: {
      name: "5 days after past due SMS"
    },
    c10: {
      name: "7 days after past due SMS"
    },
    c11: {
      name: "10 days after past due SMS"
    },
    c12: {
      name: "14 days after past due SMS"
    },
    c13: {
      name: "30 days after past due SMS"
    },
    c14: {
      name: "45 days after past due SMS"
    },
    c15: {
      name: "Day that payment is due Email"
    },
    c16: {
      name: "1 day after past due Email"
    },
    c17: {
      name: "2 days after past due Email"
    },
    c18: {
      name: "3 days after past due Email"
    },
    c19: {
      name: "5 days after past due Email"
    },
    c20: {
      name: "7 days after past due Email"
    },
    c21: {
      name: "10 days after past due Email"
    },
    c22: {
      name: "14 days after past due Email"
    },
    c23: {
      name: "30 days after past due Email"
    },
    c24: {
      name: "45 days after past due Email"
    },
    c25: {
      name: "SMS Link Clicked"
    },
    c26: {
      name: "Recurring SMS"
    },
    c27: {
      name: "Recurring Email"
    },
    c28: {
      name: "Day that payment is due Call"
    },
    c29: {
      name: "1 day after past due Call"
    },
    c30: {
      name: "2 days after past due Call"
    },
    c31: {
      name: "3 days after past due Call"
    },
    c32: {
      name: "5 days after past due Call"
    },
    c33: {
      name: "7 days after past due Call"
    },
    c34: {
      name: "10 days after past due Call"
    },
    c35: {
      name: "14 days after past due Call"
    },
    c36: {
      name: "30 days after past due Call"
    },
    c37: {
      name: "45 days after past due Call"
    },
    c38: {
      name: "Recurring Call"
    },
    c39: {
      name: "Email Link Clicked"
    },
    c40: {
      name: "SMS Sent"
    },
    c41: {
      name: "Email Sent"
    },
    c42: {
      name: "Call Made"
    },
    c43: {
      name: "LeaseId",
      variable: VarKey.UserLeaseId
    }
  }
};
